// Community Attendance APIs

/**
 * @function ApiClient#GetAttendanceInfo
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} date
 * @param {any} options = {}
 */
export async function GetAttendanceInfo(cid, date, options = {}) {
  return await this._get(`/community/${cid}/attendance_info?d=${date}`, options);
}

/**
 * @function ApiClient#GetAttendanceRecords
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} startDate
 * @param {any} endDate
 * @param {any} department
 * @param {any} internalPeopleID
 * @param {any} options = {}
 */
export async function GetAttendanceRecords(cid, startDate, endDate, department, internalPeopleID, options = {}) {
  const dept = department || "";
  const peopleID = internalPeopleID || "";

  return await this._get(`/community/${cid}/attendance_records?s=${startDate}&e=${endDate}&d=${dept}&i=${peopleID}`, options);
}

// ==================== 考勤簽核 API ====================

/**
 * @function ApiClient#GetAttendanceLeaveList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function GetAttendanceLeaveList(cid, params = {}, options = {}) {
  const queryParams = new URLSearchParams();
  if (params.department) queryParams.append("d", params.department);
  if (params.name) queryParams.append("n", params.name);
  if (params.status) queryParams.append("s", params.status);
  if (params.startTime) queryParams.append("st", params.startTime);
  if (params.endTime) queryParams.append("et", params.endTime);

  const queryString = queryParams.toString();
  const url = `/community/${cid}/attendance_leave_list${queryString ? "?" + queryString : ""}`;
  return await this._get(url, options);
}

/**
 * @function ApiClient#GetAttendanceLeaveDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} leaveId
 * @param {any} options = {}
 */
export async function GetAttendanceLeaveDetail(cid, leaveId, options = {}) {
  return await this._get(`/community/${cid}/attendance_leave/${leaveId}`, options);
}

/**
 * @function ApiClient#ReviewAttendanceLeave
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} leaveId
 * @param {any} approved
 * @param {any} note
 * @param {any} options = {}
 */
export async function ReviewAttendanceLeave(cid, leaveId, approved, note, options = {}) {
  const payload = { Approved: approved };
  if (note) payload.Note = note;
  return await this._put(`/community/${cid}/attendance_leave/${leaveId}/review`, payload, options);
}

/**
 * @function ApiClient#ApproveAttendanceLeave
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} leaveId
 * @param {any} note
 * @param {any} options = {}
 */
export async function ApproveAttendanceLeave(cid, leaveId, note, options = {}) {
  const payload = {};
  if (note) payload.Note = note;
  return await this._put(`/community/${cid}/attendance_leave/${leaveId}/approve`, payload, options);
}

/**
 * @function ApiClient#VoidAttendanceLeave
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} leaveId
 * @param {any} note
 * @param {any} options = {}
 */
export async function VoidAttendanceLeave(cid, leaveId, note, options = {}) {
  const payload = {};
  if (note) payload.Note = note;
  return await this._put(`/community/${cid}/attendance_leave/${leaveId}/void`, payload, options);
}
